export const CREDIT_TYPE_LABEL = {
  fitness: { es: "Fitness adulto", en: "Adult fitness", fr: "Fitness adulte" },
  calisthenics: { es: "Calisthenics", en: "Calisthenics", fr: "Calisthenics" },
  private: { es: "Fitness privado", en: "Private fitness", fr: "Fitness privé" },
  youth_baby: { es: "Baby (3-5 años)", en: "Baby (3-5 y/o)", fr: "Baby (3-5 ans)" },
  youth_kids: { es: "Kids (6-11 años)", en: "Kids (6-11 y/o)", fr: "Kids (6-11 ans)" },
  youth_teens: { es: "Teens (12-17 años)", en: "Teens (12-17 y/o)", fr: "Teens (12-17 ans)" },
  youth: { es: "Teens & Kids", en: "Teens & Kids", fr: "Teens & Kids" },
  pilates_group: { es: "Pilates grupal", en: "Group Pilates", fr: "Pilates collectif" },
  pilates_private: { es: "Pilates privado", en: "Private Pilates", fr: "Pilates privé" },
};

export const creditTypeLabel = (type, lang = "es") => (CREDIT_TYPE_LABEL[type] || {})[lang] || CREDIT_TYPE_LABEL[type]?.es || type || "";
